import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

import BorderButton from "../../components/BorderButton"
import PlainButton from "../../components/PlainButton";


const ArtClasses = ({ page_color, buttonSize }) => {

  const isMobile = useMediaQuery({ maxWidth: 501 });
  const isTablet = useMediaQuery({ minWidth: 501, maxWidth: 851 });
  const isSmallDesktop = useMediaQuery({ minWidth: 851, maxWidth: 1061 });
  const isDesktop = useMediaQuery({minWidth: 1061});
  
  const [flexDirection, setFlexDirection] = useState('flex-row');
  const [alignCenter, setAlignCenter] = useState('');
  const [cardWidth, setCardWidth] = useState('w-100');

  useEffect(() => {
    if (isMobile) {
      setFlexDirection('flex-column');
      setCardWidth('w-100');
    }
    
    if (isTablet) {
      setFlexDirection('flex-column');
      setCardWidth('w-100')
    }
    
    if (isSmallDesktop) {
      setFlexDirection('flex-column');
      setAlignCenter('align-items-center');
      setCardWidth('w-75');
    }
    
    if (isDesktop) {
      setFlexDirection('flex-row');
      setAlignCenter('');
      setCardWidth('w-100');
    }
  }, [isMobile, isTablet, isSmallDesktop, isDesktop]);

  
  return (

    <>
    
      <div className="d-flex flex-column">
        <div className='text-center'>
          <h1 className={`mb-2 font-custom`}>Art Classes</h1>
        </div>

        <div className={`px-2 d-flex ${flexDirection} ${alignCenter} gap-3`}>
          <div className={`${cardWidth} card text-center border-${page_color} bg-${page_color}`}>
            <div className='card-body'>
              <h2 className={`card-title font-custom`}>Mediums</h2>
              <p className='card-text'>For the painter we teach Oil, Acrylics, and Watercolors. For the sketcher we teach Pencils, Pastels, Charcoal, and Ink Pen. We also teach Sculpting.</p>
            </div>
          </div>
        
          <div className={`${cardWidth} card text-center border-${page_color} bg-${page_color}`}>
            <div className='card-body'>
              <h2 className={`card-title font-custom`}>Teachers</h2>
              <p className='card-text'>Art Alive has many teachers with various qualifications and years of experience.</p>
              <PlainButton url='/teachers' button_color='bright-accent'>Meet Our Teachers</PlainButton>
            </div>
          </div>
        
          <div className={`${cardWidth} card text-center border-${page_color} bg-${page_color}`}>
            <div className='card-body'>
              <h2 className={`card-title font-custom`}>Availability & Class Times</h2>
              <p className='card-text'>We have morning classes for adults, afternoon classes for children Mondays to Saturdays, as well as Wednesday Evening classes for adults.</p>
              <div className='d-flex gap-3 justify-content-center'>
                <PlainButton url='/classes' button_color='bright-accent'>Our Classes</PlainButton>
                <PlainButton url='/contact' button_color='bright-accent'>Join</PlainButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    </>

  );

}


export default ArtClasses;